import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {CustomDateModel} from "../custom-date.model";
import {ValueAndLabelConverter} from "../../../converter/ValueAndLabel.converter";
import {DateConverter} from "../../../converter/date.converter";

export class CustomDateConverter extends HttpModelConverter<CustomDateModel>{
    protected createInstance(): CustomDateModel {
        return new CustomDateModel();
    }

    protected enrichObject(result: CustomDateModel, src: CustomDateModel) {
        result.type = new ValueAndLabelConverter().convert(src.type);
        result.date = new DateConverter().convert(src.date);
    }
}